const localeConfig: {[key: string]: string} = {
    "fr-FR": "fr_FR",
    "en-US": "en_US",
    "nl-NL": "nl_NL",
    "fr-FR-CSE": "fr_FR_CSE",
    "nl-NL-YN": "nl_NL_YN",
    "fr-FR-YN": "fr_FR_YN",
}


export const companyLangToLocale: Map<string, string> = new Map([
    ["fr", "fr-FR"],
    ["en", "en-US"],
    ["nl", "nl-NL"]
]);


// Used only by SearchEngineService to get the correct locale for the headers
export const localeByDomainMap: Map<string, string> = new Map([
    ["localhost", "fr-FR"], // For testing purposes attention COMPANY CAN FORCE TO FR
    ["www.fr.yoonly.eu", "fr-FR-YN"],
    ["www.nl.yoonly.eu", "nl-NL-YN"],
    ["www.befr.yoonly.eu", "fr-FR-YN"],
    ["www.benl.yoonly.eu", "nl-NL-YN"],
    ["www.travelski.com", "fr-FR"],
    ["www.uk.travelski.com", "en-US"],
    ["www.nl.travelski.com", "nl-NL"],
    ["cse.travelski.com", "fr-FR-CSE"],
]);

export default localeConfig